import { Component } from '@angular/core';
import { HvtSection5Dto, OjeuContractAwardDto } from '../../../models/notices/ojeu.notice.models';
import { FormType } from '../../../models/notices/ojeu.notice.enums';
import { SelectableItem } from '../../../models/common/selectableItem';
import { HvtSectionBase } from './hvt.section.base';

@Component({
    selector: 'hvt-s5',
    template: require('./hvt.section.5.component.html')
})
export class HvtS5Component extends HvtSectionBase<HvtSection5Dto> {
    hvtS5: HvtSection5Dto;

    constructor() {
        super();
    }

    populate(hvtS5: HvtSection5Dto, formType: FormType) {
        this.hvtS5 = hvtS5;
        this.formType = formType;
    }

    clear() {
        this.hvtS5 = null;
        this.formType = null;
    }

    get sectionTitle(): string {
        switch (this.formType) {
            case FormType.F152014:
                {
                    return 'Award of contract/concession';
                }
            case FormType.F032014:
            case FormType.F062014:
            case FormType.F212014:
            default:
                {
                    return 'Award of contract';
                }
        }
    }

    get showContractAwarded(): boolean {
        return this.formType === FormType.F032014 || this.formType === FormType.F062014 || this.formType === FormType.F212014 || this.formType === FormType.F152014;
    }

    get v2s1Title(): string {
        switch (this.formType) {
            case FormType.F152014:
                {
                    return 'Date of conclusion of the contract/concession award decision';
                }
            case FormType.F032014:
            case FormType.F062014:
            case FormType.F212014:
            default:
                {
                    return 'Date of conclusion of the contract';
                }
        }
    }

    get v2s3Title(): string {
        switch (this.formType) {
            case FormType.F152014:
                {
                    return 'Name and address of the contractor/concessionaire';
                }
            case FormType.F032014:
            case FormType.F062014:
            case FormType.F212014:
            default:
                {
                    return 'Name and address of the contractor';
                }
        }
    }

    get v2s3ContractorText() {
        switch (this.formType) {
        case FormType.F152014:
        {
                    return 'The contractor/concessionaire is an SME';
        }
        case FormType.F032014:
        case FormType.F062014:
        case FormType.F212014:
        default:
        {
                    return 'The contractor is an SME';
        }
        }
    }

    v2s4Title(award: OjeuContractAwardDto): string {
        switch (this.formType) {
            case FormType.F152014:
                {
                    return `Information on value of the contract/lot/concession (excluding VAT)${award.agreeToPublishValue !== null ? ` (Agree to publish? ${award.agreeToPublishValue ? 'yes' : 'no'})` : '' }`;
                }
            case FormType.F032014:
            case FormType.F062014:
            case FormType.F212014:
            default:
                {
                    return `Information on value of the contract/lot (excluding VAT)${award.agreeToPublishValue !== null ? ` (Agree to publish? ${award.agreeToPublishValue ? 'yes' : 'no'})` : '' }`;
                }
        }
    }

    showSectionV2s2(award: OjeuContractAwardDto) {
        return this.formType !== FormType.F062014 ||
            award.tendersReceived !== null ||
            award.tendersReceivedSme !== null ||
            award.tendersReceivedEmeans !== null ||
            award.tendersReceivedNonEu !== null ||
            award.tendersReceivedOtherEu !== null;
    }

    showSectionV2s6() {
        return this.formType === FormType.F062014;
    }

    get valueObjectName() {
        switch (this.formType) {
        case FormType.F152014:
        {
            return 'contract/lot/concession';
        }
        case FormType.F032014:
        case FormType.F062014:
        case FormType.F212014:
        default:
        {
            return 'contract/lot';
        }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.5.component.ts